module.exports = __webpack_public_path__ + "img/stablecoins.90a6499e.png";